<template>
  <div class="cCardView">
    <netpay-card></netpay-card>
  </div>
</template>

<script>
// @ is an alias to /src
import netpayCard from "@/components/methods/netpayCard.vue";

export default {
  name: "netpay",

  components: {
    netpayCard
  },
  created() {}
};
</script>


